import { render, staticRenderFns } from "./DefectStaticCard.vue?vue&type=template&id=e4cb1eda&scoped=true&"
import script from "./DefectStaticCard.vue?vue&type=script&lang=js&"
export * from "./DefectStaticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cb1eda",
  null
  
)

export default component.exports